<template>
	<div class="wrapper">
		<ShareHeader :openTarget="'user/home?id=' + uid" />
		<div id="topBanner" class="topBanner" ref="topBanner"></div>
		<div class="contentSection">
			<div class="userAvatar">
				<img :src="userData.avatar" alt="">
			</div>
			<div class="userDesc">
				<span class="userName">{{userData.nickname || userData.username}}</span><span class="level"><img src="@/assets/image/personalCenter/blue_star.png">{{userData.level_name}}</span>
			</div>
			<div class="subTitle">{{userData.sightml}}</div>
			<div class="statistic">
				<span class="statisticText">关注</span>
				<span class="statisticNum">{{userData.following}}</span>
				<span class="statisticText">粉丝</span>
				<span class="statisticNum">{{userData.follower}}</span>
			</div>

			<div class="powerSection">
				<span class="powerTitle">影响力</span>
				<span class="powerText">主题<span class="powerNum">{{userData.posts}}</span></span>
				<span class="powerText">被阅<span class="powerNum">{{userData.total_view_num}}</span></span>
				<span class="powerText">视频<span class="powerNum">{{userData.total_course_num}}</span></span>
				<span class="powerText">被赞<span class="powerNum">{{userData.total_like_num}}</span></span>
			</div>

			<div class="followSection">
				<div class="followSectionTitle"><span class="icon"><img src="@/assets/image/personalCenter/hot_follow.png"></span>热门关注</div>
				<div class="followAvatar">
					<img v-for="user of followList" :src="user.avatar" :key="user.uid">
					<span class="moreSpan">更多</span>
				</div>
				<div class="middleFollowButton"><WxOpenTag :extinfo="'user/home?id=' + uid" /></div>
			</div>
			<div class="topFollowButton">
				打开APP关注
				<WxOpenTag :extinfo="'user/home?id=' + uid" />
			</div>
		</div>
		
		<div class="tabSection">
			<div class="tabWrapper">
				<div class="tabItem" :class="{active: activeTab === 'dynamics'}" @click="handleTabItemClick('dynamics')">动态</div>
				<div class="tabItem" :class="{active: activeTab === 'topic'}" @click="handleTabItemClick('topic')">主题</div>
				<div class="tabItem" :class="{active: activeTab === 'reply'}" @click="handleTabItemClick('reply')">回复</div>
				<div class="tabItem" :class="{active: activeTab === 'study'}" @click="handleTabItemClick('study')">学习</div>
			</div>
		</div>
		<PersonalCenterShareTab :type="activeTab" :uid="uid" />
		<div class="bittomFollowButton">
			打开APP查看更多
			<WxOpenTag :extinfo="'user/home?id=' + uid" />
		</div>
	</div>
</template>

<script>
import WxShare from '@/utils/wxshare'
import WxOpenTag from '@/components/WxOpenTag'
import ShareHeader from '@/components/HeadModule'
import PersonalCenterShareTab from './PersonalCenterShareTab'
export default {
	data(){
		return {
			activeTab: this.$route.query.active || 'dynamics',
			uid: this.$route.query.uid,
			userData: {},
			followList: [],
		}
	},
	mounted(){
		this.init()
	},
	methods: {
		init(){
			this.getUserInfo()
			this.getRecommendUsers()
		},
		getUserInfo(){
			this.$http.get('/User/userDetails', {
				params: {
					fuid: this.uid
				}
			}).then(res => {
				if(res.code >= 0){
					this.userData = res.data
					this.$refs.topBanner && (this.$refs.topBanner.style.backgroundImage = `url('${res.data.cover}')`)
					new WxShare().share({
						title: res.data.username,
						desc: res.data.sightml || '',
						link: window.location.href,
						imgUrl: res.data.avatar
					})
				}
			})
		},
		getRecommendUsers(){
			this.$http.get('/index/recommendMember', {
				params: {
					start: 0,
					limit: 5
				}
			}).then(res => {
				if(res.code >= 0){
					this.followList = res.data
				}
			})
		},
		handleTabItemClick(activeTab){
			if(this.activeTab === activeTab) return
			this.activeTab = activeTab
		},
	},
	components: {
		ShareHeader: ShareHeader,
		PersonalCenterShareTab: PersonalCenterShareTab,
		WxOpenTag: WxOpenTag
	}
}
</script>

<style scoped>
.wrapper{
	padding-bottom: 10px;
	background-color: #f7f8f8;
}
.title{
	display: inline;
	font-size: 18px;
	font-weight: 600;
	color: #1d2023;
	padding: 0;
	margin: 0;
}
.icon{
	display: inline-block;
	width: 20px;
	margin-right: 3px;
	vertical-align: middle;
	flex-shrink: 0;
}
.icon > img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.line{
	margin: 0 15px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.topBanner{
	padding-top: 190px;
	padding-top: calc(100% / 1.44 - 50);
	background: #d8d8d8 no-repeat;
	background-size: cover;
	background-position: center;
}
.contentSection{
	position: relative;
	margin-top: -24px;
	padding: 20px 15px 10px 15px;
	font-size: 16px;
	border-radius: 24px 24px 0 0;
	background: #f7f8f8;
}
.userAvatar{
	width: 80px;
	height: 80px;
	margin-top: -50px;
	border: 2px solid #fff;
	border-radius: 50%;
	background-color: #f7f8f8;
	overflow: hidden;
}
.userAvatar > img{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.topFollowButton{
	position: absolute;
	top: 12px;
	right: 15px;
	padding: 5px 10px;
	background-color: #f7443f;
	font-size: 14px;
	color: #fff;
	text-align: center;
	border-radius: 20px;
	overflow: hidden;
}
.userDesc{
	margin: 10px 0 5px 0;
}
.userDesc > .userName{
	font-size: 21px;
	color: #1d2023;
	font-weight: 600;
}
.userDesc > .level{
	margin-left: 8px;
	padding: 3px 5px;
	font-size: 9px;
	color: #2086fc;
	background-color: #e2effe;
	border-radius: 2px;
}
.level > img{
	width: 10px;
	height: 10px;
	margin-right: 2px;
}

.subTitle{
	font-size: 14px;
	color: #606972;
}
.statistic{
	display: table;
	margin-top: 5px;
	font-size: 10px;
	color: #606972;
}
.statisticText{
	display: table-cell;
	padding-left: 15px;
	vertical-align: middle;
}
.statisticText:first-child{
	padding-left: 0;
}
.statisticNum{
	display: table-cell;
	padding-left: 5px;
	font-size: 14px;
	color: #1d2023;
	vertical-align: middle;
}

.powerSection{
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 15px 0;
	padding: 15px 10px;
	font-size: 10px;
	color: #606972;
	background-color: #fff;
	border-radius: 6px;
	overflow: hidden;
	box-shadow: 0 0 10px #ddd;
}
.powerTitle{
	position: relative;
	font-size: 16px;
	color: #1d2023;
	padding-left: 8px;
}
.powerTitle:before{
	content: '';
	position: absolute;
	left: 0;
	display: block;
	width: 4px;
	height: 100%;
	background-color: #f7443f;
	border-radius: 3px;
	overflow: hidden;
}
.powerText{
	display: flex;
	align-items: center;
}
.powerNum{
	margin-left: 3px;
	font-size: 14px;
	color: #e50120;
}


.followSectionTitle{
	font-size: 16px;
	color: #1d2023;
}
.followAvatar{
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: nowrap;
	margin: 10px 0 10px 0;
	overflow: hidden;
}
.followAvatar > img{
	width: 45px;
	height: 45px;
	border-radius: 50% 50%;
	border: 1px solid #fff;
	object-fit: cover;
	background-color: #d8d8d8;
}
.moreSpan{
	display: inline-block;
	width: 45px;
	height: 45px;
	font-size: 11px;
	color: #fff;
	text-align: center;
	line-height: 45px;
	border-radius: 50% 50%;
	border: 1px solid #fff;
	background-color: #fbd249;
}

.middleFollowButton{
	position: relative;
	width: 200px;
	height: 55px;
	margin: 0 auto;
	background-image: url("../../../assets/image/personalCenter/open_app_button.png");
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}


.tabSection{
	background-color: #fff;
}
.tabWrapper{
	display: flex;
	justify-content: space-between;
	height: 50px;
	/*border-bottom: 1px solid transparent;
	border-image: linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.5) 50%) 0 0 100%;*/
}
.tabWrapper .tabItem{
	position: relative;
	flex: 1;
	height: 100%;
	font-size: 18px;
	color: #3f454b;
	font-weight: 500;
	line-height: 50px;
	text-align: center;
	box-sizing: border-box;
}
.tabWrapper .tabItem.active{
	color: #1d2023;
	font-weight: 600;
}
.tabWrapper .tabItem.active:after{
	display: block;
	content: '';
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 50px;
	height: 2px;
	background-color: #e50120;
}

.bittomFollowButton{
	position: relative;
	margin: 15px;
	padding: 8px;
	font-size: 16px;
	color: #fff;
	text-align: center;
	border-radius: 5px;
	overflow: hidden;
	background-color: #e50120;
}

</style>